import {Component, h, Prop, Event, type EventEmitter, Watch, State, Method} from '@stencil/core';
import type {FacetChildUiModel} from '../../../models/ui/facets/facet-tree-ui.model';
import type {BooleanString} from '../../../models/common/types/boolean-string.type';
import {isMobile} from '../../../utils/media';

@Component({
  tag: 'filter-checkbox',
  styleUrl: 'filter-checkbox.scss',
  shadow: true,
})
export class FilterCheckbox {
  @Prop() readonly filter: FacetChildUiModel;
  @Prop() readonly titleName: string;
  @Prop() readonly rtl: boolean;

  @Prop({attribute: 'selected', mutable: true}) selectedProp: BooleanString = 'false';
  @Prop({attribute: 'label'}) readonly labelProp: string;
  @Prop({attribute: 'has-paddings'}) readonly hasPaddings: BooleanString = 'false';

  @Event({bubbles: false}) selectChange: EventEmitter<boolean>;

  @State() mobileView: boolean = isMobile();
  @State() selectedState: boolean;
  @State() disabledState: boolean = false;

  private labelState: string;
  private hasPaddingsBool: boolean;

  @Method()
  async setSelected(bool: boolean) {
      this.selectedProp = bool ? 'true' : 'false';
  }

  @Method()
  async setDisabled(bool: boolean) {
      this.disabledState = bool;
  }

  private onChange(): void {
      this.selectedProp = !this.selectedState ? 'true' : 'false';
      this.selectedState = !this.selectedState;
      this.selectChange.emit(this.selectedState);
  }

  private setStates(): void {
      this.labelState = this.labelProp;
      this.selectedState = this.selectedProp === 'true';
      this.hasPaddingsBool = this.hasPaddings === 'true';
  }

  componentWillLoad() {
      this.setStates();
  }

  componentWillUpdate() {
      this.setStates();
  }

  render() {
      return (
        <div
          dir={this.rtl ? 'rtl' : 'auto'}
          class={
            {'filter-checkbox-wrapper': true,
             'has-paddings': this.hasPaddingsBool,
             'filter-disabled': this.disabledState
            }}>
          <label class={'checkbox-label'} onClick={() => this.onChange()}>
            <span class="filter-checkbox-text">
              <se-checkbox
                title={this.titleName}
                selected={this.selectedState}
                disabled={this.disabledState}
              ></se-checkbox>
              <span
                dir={this.rtl ? 'rtl' : 'auto'}
                class={`checkbox-text ${this.mobileView ? '' : 'smaller-label'}`}
                innerHTML={`${this.labelState}`}
              >
              </span>
            </span>
            <slot name="icon" />
          </label>
        </div>
      );
  }
}
